import React, { useEffect, useState } from "react";
import "./AdminOrdersPage.css";

const AdminOrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterStatus, setFilterStatus] = useState("ALL");
  const [selectedOrder, setSelectedOrder] = useState(null); // Modal के लिए

  // 🚀 Safe Currency Formatter Helper
  const formatCurrency = (amount) => {
    const val = parseFloat(amount);
    return isNaN(val) ? "0" : val.toLocaleString("en-IN");
  };

  const fetchAllOrders = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("admin_token"); // Token retrieve

      const response = await fetch(
        "https://rbuymart.rbhardwaj.com/server/api/admin/get_all_orders.php",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : "",
          },
        },
      );

      const data = await response.json();

      if (data.status === "success") {
        setOrders(data.orders || []);
      } else {
        setError(data.message || "Failed to fetch orders");
      }
    } catch (err) {
      setError("Network error. Failed to connect to server.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllOrders();
  }, []);

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      const token = localStorage.getItem("adminToken");
      const response = await fetch(
        `https://rbuymart.rbhardwaj.com/server/api/admin/update_order_status.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : "",
          },
          body: JSON.stringify({ order_id: orderId, order_status: newStatus }),
        },
      );
      const data = await response.json();

      if (data.status === "success") {
        const isDelivered = newStatus.toLowerCase() === "delivered";

        setOrders((prevOrders) =>
          prevOrders.map((order) =>
            order.id === orderId
              ? {
                  ...order,
                  order_status: newStatus,
                  payment_status: isDelivered ? "paid" : order.payment_status,
                }
              : order,
          ),
        );

        if (selectedOrder && selectedOrder.id === orderId) {
          setSelectedOrder((prev) => ({
            ...prev,
            order_status: newStatus,
            payment_status: isDelivered ? "completed" : prev.payment_status,
          }));
        }
        alert("Order status updated successfully!");
      } else {
        alert(data.message || "Failed to update status");
      }
    } catch (err) {
      alert("Error updating status.");
    }
  };

  const filteredOrders = orders.filter((order) => {
    if (filterStatus === "ALL") return true;
    return (order.order_status || "PENDING").toUpperCase() === filterStatus;
  });

  if (loading)
    return <div className="admin-loader">Loading Admin Orders Matrix...</div>;
  if (error) return <div className="admin-error-banner">{error}</div>;

  return (
    <div className="admin-orders-container">
      <div class="admin-header-tap">
     
          <h3>Orders</h3>
        <div className="flex-div">
             <button onClick={() => window.print()} className="btn-print">
            <i className="material-icons">&#xe8ad;</i> Print
          </button>

          <div className="formlabeldiv">
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="ALL">All Orders</option>
              <option value="PENDING">Pending</option>
              <option value="PROCESSING">Processing</option>
              <option value="SHIPPED">Shipped</option>
              <option value="DELIVERED">Delivered</option>
              <option value="CANCELLED">Cancelled</option>
            </select>
         
          </div>
       
        </div>
      </div>
 

      <div className="table-div">
        <table>
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Date</th>
              <th>Customer</th>
              <th>Phone</th>
              <th>Amount</th>
              <th>Payment Type</th>
              <th>Payment</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.length === 0 ? (
              <tr>
                <td
                  colSpan="9"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No orders found for this filter.
                </td>
              </tr>
            ) : (
              filteredOrders.map((order) => (
                <tr key={order.id}>
                  <td>
                    <strong>#{order.id}</strong>
                  </td>
                  <td>
                    {order.created_at
                      ? new Date(order.created_at).toLocaleDateString("en-IN")
                      : "N/A"}
                  </td>
                  <td>
                    <div>{order.shipping_address?.name || "Guest User"}</div>
                  </td>
                  <td>{order.shipping_address?.phone || "N/A"}</td>
                  <td>
                    <strong>₹{formatCurrency(order.grand_total)}</strong>
                  </td>
                  <td>
                    <span className={`badge-payment ${order.payment_method}`}>
                      {order.payment_method || "N/A"}
                    </span>
                  </td>
                  <td>
                    <span
                      className={`badge-payment ${(order.payment_status || "pending").toUpperCase()}`}
                    >
                      {order.payment_status || "pending"}
                    </span>
                  </td>
                  <td>
                    <select
                      className={`status-dropdown ${(order.order_status || "pending").toLowerCase()}`}
                      value={(order.order_status || "pending").toLowerCase()}
                      onChange={(e) =>
                        handleStatusChange(order.id, e.target.value)
                      }
                    >
                      <option value="pending">Pending</option>
                      <option value="processing">Processing</option>
                      <option value="shipped">Shipped</option>
                      <option value="delivered">Delivered</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                  </td>
                  <td>
                    <button
                      className="btn-view"
                      onClick={() => setSelectedOrder(order)}
                    >
                      <i className="material-icons">&#xe417;</i> Details
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {selectedOrder && (
        <div
          className="admin-modal-overlay"
          onClick={() => setSelectedOrder(null)}
        >
          <div
            className="admin-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3>Details for Order #{selectedOrder.id}</h3>
              <button
                className="btn-close-modal"
                onClick={() => setSelectedOrder(null)}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-grid">
                {/* Shipping Address Block */}
                <div className="modal-card">
                  <h4>Customer & Shipping Details</h4>
                  {selectedOrder.shipping_address ? (
                    <p>
                      <strong>Name:</strong>{" "}
                      {selectedOrder.shipping_address.name}
                      <br />
                      <strong>Phone:</strong>{" "}
                      {selectedOrder.shipping_address.phone}
                      <br />
                      <strong>Address:</strong>{" "}
                      {selectedOrder.shipping_address.address_line1},{" "}
                      {selectedOrder.shipping_address.address_line2 || ""}
                      <br />
                      <strong>City/State:</strong>{" "}
                      {selectedOrder.shipping_address.city},{" "}
                      {selectedOrder.shipping_address.state} -{" "}
                      {selectedOrder.shipping_address.pincode}
                      <br />
                      <strong>Type:</strong>{" "}
                      <span className="address-type-tag">
                        {selectedOrder.shipping_address.address_type}
                      </span>
                    </p>
                  ) : (
                    <p className="text-error">
                      No shipping address attached to this order.
                    </p>
                  )}
                </div>

                <div className="modal-card">
                  <h4>Order Financial Summary</h4>
                  <table className="summary-mini-table">
                    <tbody>
                      <tr>
                        <td>Subtotal:</td>
                        <td>₹{formatCurrency(selectedOrder.subtotal)}</td>
                      </tr>
                      <tr>
                        <td>GST:</td>
                        <td>₹{formatCurrency(selectedOrder.gst_total)}</td>
                      </tr>
                      <tr>
                        <td>Shipping:</td>
                        <td>
                          ₹{formatCurrency(selectedOrder.shipping_charges)}
                        </td>
                      </tr>
                      <tr>
                        <td>Discount:</td>
                        <td>₹{formatCurrency(selectedOrder.discount)}</td>
                      </tr>
                      <tr className="grand-row">
                        <td>
                          <strong>Grand Total:</strong>
                        </td>
                        <td>
                          <strong>
                            ₹{formatCurrency(selectedOrder.grand_total)}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="modal-items-section">
                <h4>Ordered Products ({selectedOrder.items?.length || 0})</h4>
                <div className="modal-items-list">
                  {selectedOrder.items &&
                    selectedOrder.items.map((item, idx) => (
                      <div
                        key={idx}
                        className="modal-item-row"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        {item.image && (
                          <img
                            src={item.image}
                            alt={item.product_name}
                            style={{
                              width: "50px",
                              height: "50px",
                              objectFit: "cover",
                              borderRadius: "6px",
                            }}
                          />
                        )}
                        <div className="item-info" style={{ flexGrow: 1 }}>
                          <h5 style={{ margin: 0 }}>{item.product_name}</h5>
                          <small>SKU: {item.sku || "N/A"}</small>
                        </div>
                        <div className="item-pricing">
                          <span>
                            ₹{formatCurrency(item.price)} &times;{" "}
                            {item.quantity}
                          </span>
                          <br />
                          <strong>
                            ₹
                            {formatCurrency(
                              (parseFloat(item.price) || 0) * item.quantity,
                            )}
                          </strong>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminOrdersPage;
